import { IEngagementContext, TNotificationOrigin } from '~/domain/OfficeNotification';
import PosthogService from '~/services/posthog/PosthogService';

export interface IOfficeNotificationCandidateAppliedCounterPayload {
  origin: TNotificationOrigin;
  shiftId: string;
  /** From the email link, which does not always carry one. */
  professionalId?: string;
  engagement: IEngagementContext;
}

/**
 * Fires when an office lands on the Confirm Candidate page from a
 * "candidate applied with counter" email CTA.
 * Event: dental_portal:office_notification:candidate_applied_counter
 */
export function fireOfficeNotificationCandidateAppliedCounter(
  payload: IOfficeNotificationCandidateAppliedCounterPayload,
): void {
  PosthogService.getInstance().track(
    'dental_portal:office_notification:candidate_applied_counter',
    {
      origin: payload.origin,
      shift_id: payload.shiftId,
      professional_id: payload.professionalId,
      ...payload.engagement,
    },
  );
}
